import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../../shared/api.js';

export function useWarehouses() {
  return useQuery({
    queryKey: ['catalog', 'warehouses'],
    queryFn: async () => {
      const { data } = await api.get('/catalog/warehouses');
      return data?.items || data?.warehouses || data?.data || data || [];
    },
    staleTime: 5 * 60 * 1000
  });
}

export function useWarehouseByType(type) {
  const { data: warehouses = [], isLoading } = useWarehouses();
  return useMemo(() => {
    if (!type) return { warehouse: null, isLoading };
    const w = warehouses.find((x) => x.type === type) || warehouses.find((x) => x.type === 'general');
    return { warehouse: w || null, isLoading };
  }, [warehouses, type, isLoading]);
}
